import React from 'react';
import globalsService from '../../services/GlobalsService';
import { t } from '../../services/i18nService';
import styles from './appLoader.scss';
import marketplaceSettingsService from '../../services/MarketplaceSettingsService';
import marketPlaces from '../../constants/MarketPlaces';

class Loading extends React.Component {
    render() {
        const isCambridgeTheme = marketplaceSettingsService.getMarketplaceName(window.marketplaceName) === marketPlaces.cambridge;
        const isFjordTheme = marketplaceSettingsService.getMarketplaceName(window.marketplaceName) === marketPlaces.fjord;
        const assetRoot = globalsService.getAssetRoot();
        let themeSuffix = '';
        if (isCambridgeTheme) themeSuffix = '-cambridge';
        if (isFjordTheme) themeSuffix = '-fjord';
        const src = `${assetRoot ? `${assetRoot}/` : ''}images/loading-spinner${themeSuffix}.svg`;
        return (
            <div className={styles.loader}>
                <svg>
                    <title>{t('status.loadingAssessment')}</title>
                    <image href={src} height="100%" width="100%" />
                </svg>
                <span className="sr-only">{t('status.loadingAssessment')}</span>
            </div>
        );
    }
}

export default Loading;
